import type { ReactNode } from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { cn } from "../../lib/format";

/** Link colour from the company area design. */
export const authLink =
  "text-brand no-underline transition-colors hover:text-brand-link";

interface AuthLayoutProps {
  /** narrow: login / password reset. wide: signup forms on a 2-column grid. */
  width?: "narrow" | "wide";
  activeHref?: string;
  children: ReactNode;
}

/** Grey page with a centred white card, as in the company area design. */
export default function AuthLayout({
  width = "narrow",
  activeHref,
  children,
}: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-surface">
      <Header activeHref={activeHref} />

      <main className="flex flex-1 items-start justify-center px-4 py-10 sm:py-20">
        <div
          className={cn(
            "w-full rounded-card bg-white p-6 sm:p-8",
            width === "narrow" ? "max-w-115" : "max-w-160",
          )}
        >
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}

interface AuthHeadingProps {
  title: string;
  subtitle: string;
}

export function AuthHeading({ title, subtitle }: AuthHeadingProps) {
  return (
    <>
      <h1 className="m-0 text-[26px] font-medium tracking-[-0.01em] text-ink">
        {title}
      </h1>
      <p className="mt-2 mb-6 text-sm leading-normal text-muted">{subtitle}</p>
    </>
  );
}
